import Plot from 'react-plotly.js';

function BarPlot({ title,xAxis,yAxis,x,y,ori='v' }) {
    //let colors=Array(info.length).fill('rgb(27, 187, 171)')
    return (
            <Plot
                data={[
                    {
                        type: 'bar',
                        x: x,
                        y: y,
                        orientation: ori
                       // marker:{color: colors}
                    }
                ]}
                layout={{
                    title: {text: title},
                    xaxis: {title: {text: xAxis}},
                    yaxis: {title: {text: yAxis}},
                    autosize: true
                }}
                style={{ width: '50%', height: '100%'}}
                useResizeHandler={true}
            />
    )
}
export default BarPlot;